export default __webpack_public_path__ + "static/media/stairs.77fb0cf1.png";